export default __webpack_public_path__ + "static/media/visa.002591cc.svg";